import { forwardRef, RefObject } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import editSvg from 'assets/icons/edit.svg';
import { changeDealData } from 'store/dealManagement/reducer';
import Input from 'lib/Input';
import { IconSize, InputBlurHandler, InputShape, InputSize, InputTheme } from 'components/common/types/Input.types';
import { getIsDirectSalesCampaignType } from 'store/dealManagement/selectors/getCampaignType';

type CampaignNameProps = {
  isDisabled?: boolean;
  campaignName?: string;
  onBlur?: InputBlurHandler;
};

const CampaignName = forwardRef<HTMLInputElement, CampaignNameProps>(
  ({ onBlur, campaignName, isDisabled = false }, ref) => {
    const dispatch = useDispatch();
    const isDirectSalesCampaignType = useSelector(getIsDirectSalesCampaignType);

    const handleCampaignNameChange = (name: string): void => {
      dispatch(changeDealData({ dealName: name }));
    };

    return (
      <Input
        theme={InputTheme.ITALIC_WHITE}
        placeholder={isDirectSalesCampaignType ? '{Advertiser}_{Brand}_{Sales person}' : 'New Campaign'}
        value={campaignName}
        onChange={handleCampaignNameChange}
        onBlur={onBlur}
        endIconSvg={editSvg}
        iconSize={IconSize.EXTRA_SMALL}
        size={InputSize.EXTRA_SMALL}
        shape={InputShape.ROUNDED_MEDIUM}
        className="py-1"
        name="Campaign name"
        isDisabled={isDisabled}
        inputRef={ref as RefObject<HTMLInputElement>}
      />
    );
  },
);

export default CampaignName;
